import { filesize } from 'filesize'

/**
 * @example formatDecimalMegabytes(1000) // 1 GB
 */
export default function formatDecimalMegabytes(decimalMegaBytes: number): string {
  return filesize(convertToBytes(decimalMegaBytes), { standard: 'jedec' })
}

/**
 * @example formatDecimalMegabytesArray(1000) // [1, 'GB']
 */
export function formatDecimalMegabytesArray(decimalMegaBytes: number) {
  return filesize(convertToBytes(decimalMegaBytes), {
    standard: 'jedec',
    output: 'array',
  })
}

/**
 * Keep this in-sync with tw-frontend and tw-marketing repositories
 */
function convertToBytes(decimalMegaBytes: number): number {
  if (!Number.isFinite(decimalMegaBytes)) {
    return decimalMegaBytes
  }

  let binaryBytes = 1
  while (decimalMegaBytes >= 1000) {
    decimalMegaBytes /= 1000
    binaryBytes *= 1024
  }
  return binaryBytes * decimalMegaBytes * 1024 * 1024
}
